import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwartempotraveller() {



    const cardData = {

keyword: "Pune to Mahabaleshwar Tempo Traveller",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Mahabaleshwar Tempo Traveller services for family trips, group tours, corporate outings, and weekend getaways. We provide well-maintained 9, 12, 15, and 17-seater Tempo Travellers with push-back seats, air conditioning, and experienced drivers for a smooth hill journey. With doorstep pickup from Pune, flexible one-way and round-trip options, 24/7 support, and transparent pricing, we ensure a comfortable and scenic travel experience to Mahabaleshwar hill station.",

topPlaces: [
    {
        title: "Arthur’s Seat Point",
        description:
            "Arthur’s Seat is one of the most famous viewpoints in Mahabaleshwar known for its breathtaking valley views, deep cliffs, and scenic landscapes. It offers a stunning look at the Savitri River valley and is especially beautiful during sunrise and sunset, making it a must-visit spot for travelers."
    },
    {
        title: "Venna Lake",
        description:
            "Venna Lake is a popular man-made lake surrounded by trees and hills, offering boating, horse rides, and street food stalls. It is one of the most visited family attractions in Mahabaleshwar, perfect for relaxation and leisure activities."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a famous tourist attraction known for strawberry farms, fresh fruit products, chocolate items, and delicious food. Visitors can enjoy strawberry picking, juices, and scenic garden views, making it a favorite stop for all age groups."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is a beautiful natural waterfall located on the Mahabaleshwar-Panchgani road. Surrounded by lush greenery, it offers stunning views especially during monsoon season, making it ideal for photography and nature lovers."
    },
    {
        title: "Elephant’s Head Point",
        description:
            "Elephant’s Head Point is a unique rock formation shaped like an elephant’s head, offering panoramic views of the Sahyadri mountains. It is a peaceful and scenic viewpoint ideal for group visits and sightseeing."
    },
    {
        title: "Panchgani Table Land (Nearby)",
        description:
            "Panchgani Table Land is one of the largest volcanic plateaus in Asia, offering wide-open landscapes, horse rides, and scenic viewpoints. It is a perfect extension trip from Mahabaleshwar for families and group travelers."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest point in Mahabaleshwar, famous for sunrise views over the mountains. It attracts early morning visitors who want to experience golden sunrise skies and peaceful hilltop scenery."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is a historic Maratha fort built by Chhatrapati Shivaji Maharaj. It offers rich history, strong architecture, and panoramic valley views, making it an important heritage site near Mahabaleshwar."
    },
    {
        title: "Elphinstone Point",
        description:
            "Elphinstone Point is a scenic viewpoint offering dramatic views of valleys, waterfalls, and dense forests. It is one of the less crowded yet highly scenic locations in Mahabaleshwar."
    },
    {
        title: "Tapola (Mini Kashmir)",
        description:
            "Tapola is known as Mini Kashmir due to its beautiful Shivsagar Lake and surrounding hills. It offers boating, nature views, and peaceful surroundings, making it a perfect extension trip from Mahabaleshwar."
    }
],



services: [
{
name: "Tempo Traveller from Pune to Mahabaleshwar",
description: "Rising Cab Service offers Tempo Traveller from Pune to Mahabaleshwar for a comfortable hill station group travel experience. Our AC vehicles come with spacious seating, professional drivers, and safe ghat driving, making it ideal for families, friends, and corporate outings planning a relaxing weekend trip to Mahabaleshwar."
},
{
name: "Pune to Mahabaleshwar Tempo Traveller Hire",
description: "Book Pune to Mahabaleshwar Tempo Traveller Hire with Rising Cab Service for smooth and affordable group travel. We provide well-maintained vehicles, flexible pickup options, experienced chauffeurs, and complete travel support for a hassle-free hill station journey."
},
{
name: "Pune to Panchgani Tempo Traveller",
description: "Rising Cab Service provides Pune to Panchgani Tempo Traveller for scenic hill station trips. Enjoy comfortable seating, safe driving through ghats, and flexible stops for sightseeing, photography, and family travel."
},
{
name: "Tempo Traveller for Rent in Pune",
description: "Get Tempo Traveller for Rent in Pune for local and outstation group travel. Our fleet includes AC, luxury, and standard options with professional drivers, making it suitable for weddings, tours, corporate trips, and family vacations."
},
{
name: "17 Seater Tempo Traveller for Mahabaleshwar Trip",
description: "Book 17 Seater Tempo Traveller for Mahabaleshwar Trip for large group travel with push-back seats, AC comfort, and experienced drivers. Perfect for school trips, corporate outings, and family tours to hill stations."
},
{
name: "17 Seater Tempo Traveller for Mahabaleshwar Tour Package",
description: "Rising Cab Service offers 17 Seater Tempo Traveller for Mahabaleshwar Tour Package with complete travel support, flexible itineraries, and safe ghat driving for a comfortable group holiday experience."
},
{
name: "Pune Airport to Mahabaleshwar Tempo Traveller on Rent",
description: "Book Pune Airport to Mahabaleshwar Tempo Traveller on Rent for direct pickup and comfortable hill station transfer. Ideal for tourists arriving in Pune and heading straight to Mahabaleshwar with luggage and group travel convenience."
},
{
name: "Pune to Tapola Tempo Traveller on Rent",
description: "Rising Cab Service provides Pune to Tapola Tempo Traveller on Rent for scenic lake-side and hill travel. Enjoy safe driving, comfortable seating, and flexible sightseeing stops for a relaxing getaway."
},
{
name: "14 Seater Tempo Traveller for Maharashtra Trip",
description: "Book 14 Seater Tempo Traveller for Maharashtra Trip for multi-destination travel across cities and hill stations. Perfect for group tours with AC comfort, luggage space, and professional drivers."
},
{
name: "Tempo Traveller on Rent for Mahabaleshwar Outing",
description: "Rising Cab Service offers Tempo Traveller on Rent for Mahabaleshwar Outing for family picnics, weekend trips, and group holidays with safe and comfortable travel options."
},
{
name: "Mini Bus on Rent for Mahabaleshwar Trip",
description: "Book Mini Bus on Rent for Mahabaleshwar Trip for large groups needing extra seating capacity. We provide safe, spacious, and budget-friendly travel solutions for hill station tours."
},
{
name: "Tempo Traveller Rent Per KM in Pune to Mahabaleshwar",
description: "Get transparent Tempo Traveller Rent Per KM in Pune to Mahabaleshwar with affordable pricing based on distance, vehicle type, and travel duration for complete cost clarity."
},
{
name: "Pune to Mahabaleshwar Tempo Traveller Price",
description: "Rising Cab Service offers competitive Pune to Mahabaleshwar Tempo Traveller Price with flexible packages for one day, round trip, and extended stay tours."
},
{
name: "Mahabaleshwar Tempo Traveller from Pune",
description: "Book Mahabaleshwar Tempo Traveller from Pune for smooth hill station travel with experienced drivers, AC comfort, and flexible sightseeing options."
},
{
name: "Luxury Tempo Traveller Pune to Mahabaleshwar",
description: "Rising Cab Service provides Luxury Tempo Traveller Pune to Mahabaleshwar with premium seating, LED entertainment, AC comfort, and safe ghat driving for a high-end group travel experience."
},
{
name: "AC Tempo Traveller Pune to Mahabaleshwar",
description: "Book AC Tempo Traveller Pune to Mahabaleshwar for a comfortable and cool journey through hill routes with spacious seating and professional drivers."
},
{
name: "17 Seater Tempo Traveller Pune to Mahabaleshwar",
description: "Rising Cab Service offers 17 Seater Tempo Traveller Pune to Mahabaleshwar for large groups, ensuring safe, comfortable, and well-managed hill station travel."
},
{
name: "13 Seater Tempo Traveller Pune to Mahabaleshwar",
description: "Book 13 Seater Tempo Traveller Pune to Mahabaleshwar for small group travel with comfort, safety, and affordable pricing for hill station tours."
}
],

tableData: [
["Tempo Traveller from Pune to Mahabaleshwar","Pune to Mahabaleshwar Tempo Traveller Hire"],
["Pune to Panchgani Tempo Traveller","Tempo Traveller for Rent in Pune"],
["17 Seater Tempo Traveller for Mahabaleshwar Trip","17 Seater Tempo Traveller for Mahabaleshwar Tour Package"],
["Pune Airport to Mahabaleshwar Tempo Traveller on Rent","Pune to Tapola Tempo Traveller on Rent"],
["14 Seater Tempo Traveller for Maharashtra Trip","Tempo Traveller on Rent for Mahabaleshwar Outing"],
["Mini Bus on Rent for Mahabaleshwar Trip","Tempo Traveller Rent Per KM in Pune to Mahabaleshwar"],
["Pune to Mahabaleshwar Tempo Traveller Price","Luxury Tempo Traveller Pune to Mahabaleshwar"],
["AC Tempo Traveller Pune to Mahabaleshwar","17 Seater Tempo Traveller Pune to Mahabaleshwar"],
["13 Seater Tempo Traveller Pune to Mahabaleshwar","Mahabaleshwar Tempo Traveller from Pune"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Mahabaleshwar Tempo Traveller Service",
        WhyChoosedescription: "Rising Cab Service provides spacious Tempo Traveller rentals from Pune to Mahabaleshwar for families, corporate groups, tourists, friends, and sightseeing travelers."
    },
    {
        WhyChooseheading: "Perfect for Group Tours and Family Vacations",
        WhyChoosedescription: "Our Tempo Travellers are ideal for family holidays, weekend getaways, school trips, corporate outings, destination events, and group travel."
    },
    {
        WhyChooseheading: "Multiple Tempo Traveller Seating Options",
        WhyChoosedescription: "Choose from 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options based on your travel requirements."
    },
    {
        WhyChooseheading: "Cover Mahabaleshwar and Panchgani Sightseeing",
        WhyChoosedescription: "Travel conveniently to Venna Lake, Mapro Garden, Arthur Seat Point, Wilson Point, Lingmala Waterfall, Elephant's Head Point, and Panchgani attractions."
    },
    {
        WhyChooseheading: "AC Tempo Travellers for Comfortable Travel",
        WhyChoosedescription: "Our well-maintained air-conditioned Tempo Travellers provide comfortable seating, ample luggage space, and a pleasant travel experience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Tempo Traveller pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, and nearby locations."
    },
    {
        WhyChooseheading: "Professional Drivers for Hill Station Routes",
        WhyChoosedescription: "Experienced drivers ensure safe and smooth travel through ghat sections while allowing passengers to enjoy the scenic journey."
    },
    {
        WhyChooseheading: "Customized One-Day and Multi-Day Packages",
        WhyChoosedescription: "Customers can choose one-day sightseeing tours, overnight stays, weekend trips, and customized Mahabaleshwar travel packages."
    }
]
};

const faqData = [
    {
        question: "Why should I hire a Tempo Traveller for Mahabaleshwar?",
        answer: "Tempo Travellers offer spacious seating, comfortable travel, and are ideal for group tours, family vacations, and corporate outings."
    },
    {
        question: "Which Tempo Traveller seating capacities are available?",
        answer: "We provide 12 Seater, 14 Seater, 17 Seater, 20 Seater, and luxury Tempo Traveller options."
    },
    {
        question: "Can Panchgani be included in the Mahabaleshwar trip?",
        answer: "Yes, customers can combine Mahabaleshwar and Panchgani sightseeing in a customized travel package."
    },
    {
        question: "Are AC Tempo Travellers available?",
        answer: "Yes, air-conditioned Tempo Travellers are available for comfortable travel throughout the journey."
    },
    {
        question: "Can we book a Tempo Traveller for a one-day Mahabaleshwar trip?",
        answer: "Yes, one-day sightseeing packages and same-day return trips are available."
    },
    {
        question: "Which attractions can be covered during the trip?",
        answer: "Popular attractions include Venna Lake, Mapro Garden, Arthur Seat Point, Wilson Point, Lingmala Waterfall, and Elephant's Head Point."
    },
    {
        question: "Is the Tempo Traveller suitable for corporate outings?",
        answer: "Yes, many companies hire Tempo Travellers for team outings, conferences, and employee trips to Mahabaleshwar."
    },
    {
        question: "Can families hire a Tempo Traveller for weekend vacations?",
        answer: "Yes, Tempo Travellers are one of the most popular options for family holidays and group vacations."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Mahabaleshwar Tempo Traveller?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prasad Jagtap",
        feedback:
            "Our family vacation to Mahabaleshwar was extremely comfortable. The Tempo Traveller had ample space, and the journey was enjoyable from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Neha Kulkarni",
        feedback:
            "We arranged a group trip to Mahabaleshwar and Panchgani. The vehicle was clean, the driver was professional, and everyone enjoyed a smooth and memorable journey.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Mahabaleshwar Tempo Traveller Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-mahabaleshwar-tempo-traveller.jpg",
"description": "Book Pune to Mahabaleshwar Tempo Traveller Service with Rising Cab Service for comfortable group travel to Mahabaleshwar and Panchgani. Ideal for family trips, corporate outings, and weekend hill station tours with AC tempo travellers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹24/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-mahabaleshwar-tempo-traveller"
}
};





    return (
        <div>
<Helmet>
  <title>Pune to Mahabaleshwar Tempo Traveller | Group Hill Station Tour | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Mahabaleshwar Tempo Traveller for comfortable group travel to Mahabaleshwar and Panchgani. Perfect for family trips, corporate outings, and weekend hill station tours."
/>

<meta
 name="keywords"
 content="tempo traveller from pune to mahabaleshwar, pune to mahabaleshwar tempo traveller hire, pune to panchgani tempo traveller, tempo traveller for rent in mahabaleshwar, group travel mahabaleshwar, hill station tempo traveller pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetomahabaleshwartempotraveller;